import React from "react";
import {ChipLabel} from "./index";

const DataAccessChips = ({entity}) => {
    return (
        <React.Fragment>
            {
                entity.has_ria_access && <ChipLabel label={"RIA"} className={"data-access-chip primary"}/>
            }
            {
                entity.has_fo_access && <ChipLabel label={"FO"} className={"data-access-chip secondary"}/>
            }
            {
                entity.has_ef_access && <ChipLabel label={"EF"} className={"data-access-chip success"}/>
            }
            {
                entity.has_bt_access && <ChipLabel label={"BT"} className={"data-access-chip info"}/>
            }
        </React.Fragment>
    )
}

export default DataAccessChips;